const SELECTORS = {
  mediaToggle: '[data-collection-media-toggle]',
  mediaRoot: '[data-collection-media-root]',
  reveal: '[data-collection-reveal]',
};

function setToggleState(button, isPaused) {
  button.setAttribute('aria-pressed', String(isPaused));
  button.setAttribute('aria-label', isPaused ? button.dataset.playLabel : button.dataset.pauseLabel);
  button.classList.toggle('is-paused', isPaused);
}

function handleMediaToggle(event) {
  const button = event.target.closest(SELECTORS.mediaToggle);
  if (!button) return;

  const controlledMedia = button
    .getAttribute('aria-controls')
    ?.split(' ')
    .map((id) => document.getElementById(id))
    .filter(Boolean);
  const mediaRoot = button.closest(SELECTORS.mediaRoot);
  const videos = controlledMedia?.length
    ? controlledMedia
    : [...(mediaRoot?.querySelectorAll('video, vimeo-background') || [])];
  if (!videos.length) return;

  const shouldPlay = button.getAttribute('aria-pressed') === 'true';

  videos.forEach((video) => {
    if (shouldPlay) {
      Promise.resolve(video.play()).catch(() => setToggleState(button, true));
    } else {
      video.pause();
    }
  });

  setToggleState(button, !shouldPlay);
}

function revealElements(root = document) {
  const elements = root.querySelectorAll(SELECTORS.reveal);
  if (!elements.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    elements.forEach((element) => element.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  elements.forEach((element) => {
    element.classList.add('collection-reveal--ready');
    observer.observe(element);
  });
}

document.addEventListener('click', handleMediaToggle);
revealElements();

document.addEventListener('shopify:section:load', (event) => revealElements(event.target));

